<main class="app_template_f__container" id="templateContainer">
  <app-print-header></app-print-header>
  <p-dialog [(visible)]="displayAgentes" [style]="{ width: '600px', height: '300px' }" [modal]="true">
    <ng-template pTemplate="header">
      <label><strong>Esops de exposición: </strong>
        {{ examen.esops?.length }}</label>
    </ng-template>
    <p-scrollPanel [style]="{ height: '200px' }">
      <p-table [value]="examen.esops">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 20%; text-align: center;">Código</th>
            <th style="width: 80%; text-align: center;">Concepto</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td style="text-align: center;">{{ item.codigo }}</td>
            <td style="text-align: center;">{{ item.descripcion }}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-scrollPanel>
    <p-footer>
      <p-button type="button" label="Regresar al examen" (click)="displayAgentes = false"></p-button>
    </p-footer>
  </p-dialog>

  <!-- ------------------------------------------------inicio de formulario------------------------------------------------ -->
  <form (ngSubmit)="onSubmit()" id="idFormLogin" name="formLogin" *ngIf="examForm" [formGroup]="examForm">
    <div class="form-container p-fluid">
      <!-- ------------------------------------------------encabezado------------------------------------------------ -->
      <div class="p-grid p-jc-between">
        <div class="" style="display: flex;">
          <span>
            <i (click)="goBack()" class="pi pi-arrow-left"
              style="font-size: 1rem; margin-right: 10px; cursor: pointer;"></i>
          </span>
          <label class="p-title-seccion form-examen-name-title">{{configForm.name}}</label>
        </div>

        <span class="print_hide-on-print">
          <app-print-button></app-print-button>
        </span>
      </div>
      <!-- ------------------------------------------------primer row (fecha)------------------------------------------------ -->
      <div class="p-grid">
        <div *ngIf="configForm.findField('fechaRealizacion')" class="p-field p-col-12 p-md-3">
          <app-fiel-title label="Fecha de realización" required="true"></app-fiel-title>
          <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
            {{examForm.controls.fechaRealizacion.value | date:"dd/MM/yyyy"}}
          </span>

          <p-calendar formControlName="fechaRealizacion" [showIcon]="true" dataType="date" dateFormat="dd/mm/yy"
            placeholder="dd/mm/yyyy" id="date_init" inputId="range" name="date_init" [maxDate]="maxDate"
            [minDate]="minDate" class="print_hide-on-print"
            [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaRealizacion.invalid}"
            [disabled]="examen?.modoVista === 'ver'">
          </p-calendar>

          <app-invalid-from-message *ngIf="submitted && f.fechaRealizacion.invalid"></app-invalid-from-message>
        </div>

        <!-- NRO LOTE-->
        <div class="p-field p-col-12 p-md-2">
          <app-fiel-title label="Nro. Lote"></app-fiel-title>
          <p class="readOnly">
            {{examen.lote.numeroLote}}
          </p>
        </div>

        <!-- NRO CARPETA-->
        <div class="p-field p-col-12 p-md-2">
          <app-fiel-title label="Nro. Carpeta"></app-fiel-title>
          <p class="readOnly">
            {{examen.numeroCarpeta}}
          </p>
        </div>

        <div class="p-col-12 p-md-3 print_hide-on-print custom-agentes">
          <label class="color-text" (click)="displayAgentes = true">
            Esops de exposición ({{ examen.esops?.length }})</label>
        </div>
      </div>

       <!-- Seccion Empleador -->
       <div *ngIf="configForm.findSection('Empleador')">
        <div class="p-grid">
          <label class="p-title-seccion">
            {{ configForm.findNumberSection("Empleador") }}.Datos de la empresa
          </label>
        </div>
        <p-divider></p-divider>
        <div class="p-grid">
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Razón Social"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.empresa.razonSocial }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="CUIT"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.empresa.cuit }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Establecimiento"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.nombre }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Teléfono"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.telefono }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Dirección de E-mail"></app-fiel-title>
            <p class="readOnly p-field-word-break">{{ examen.lote.establecimiento?.mail }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Domicilio"></app-fiel-title>
            <p class="readOnly">{{ examen.lote.establecimiento?.domicilio }}</p>
          </div>
        </div>
      </div>

      <!-- Seccion Trabajador -->
      <div *ngIf="configForm.findSection('Trabajador')">
        <div class="p-grid p-mt-2">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Trabajador") }}.Datos Del Trabajador
          </span>
        </div>
        <p-divider></p-divider>
        <div class="p-grid">
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Apellido y nombre" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.apellidoNombre.invalid}" alfanumericoDirective
              formControlName="apellidoNombre" id="apellidoNombre" name="apellidoNombre" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' || deshabilitarApellidoNombreTrabajador() ? true : null" />
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.apellidoNombre.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.required"></app-invalid-from-message>
            <app-invalid-from-message *ngIf="submitted && f.apellidoNombre.errors?.apellidoNombreTrabajadorValidator"
								message="{{ f.apellidoNombre.errors?.apellidoNombreTrabajadorValidatorMessage }}">
							</app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="CUIL"></app-fiel-title>
            <p class="readOnly">
              {{examen.trabajador.cuil}}
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Fecha de nacimiento" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.fechaNacimiento.value | date: "dd/MM/yyyy"}}
            </span>
            <p-calendar formControlName="fechaNacimiento" [showIcon]="true" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" name="fechaNacimiento" [maxDate]="maxDate" class="print_hide-on-print"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaNacimiento.invalid}"
              (onSelect)="calculateAge()" (onBlur)="calculateAge()"
              [disabled]="examen?.modoVista === 'ver' || examen.trabajador.fechaNacimiento">
            </p-calendar>
            <app-invalid-from-message *ngIf="submitted && f.fechaNacimiento.invalid"></app-invalid-from-message>
            </div>
        </div>
        <div class="p-grid">
          <div class="p-field p-col-12 p-md-4 p_hidden">
            <app-fiel-title label="DNI"></app-fiel-title>
            <p class="readOnly">
              {{examen.trabajador.numeroDocumento}}
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4 p_hidden">
            <app-fiel-title label="Sexo"></app-fiel-title>
            <p class="readOnly">
              {{examen.trabajador.sexo}}
            </p>
          </div>
          <div class="p-field p-col-12 p-md-4 p_hidden">
            <app-fiel-title label="Edad"></app-fiel-title>
            <p class="readOnly">
              {{ examen.trabajador.edad }} años
            </p>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-field p-col-12 p-md-4 print_row-full" *ngIf="examen.trabajador.calle!==null">
            <app-fiel-title label="Domicilio"></app-fiel-title>
            <p class="readOnly">{{ examen.trabajador.calle }}</p>
          </div>
          <div class="p-field p-col-12 p-md-4 print_row-full">
            <app-fiel-title label="Puesto de trabajo" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.puestoTrabajador.invalid}" alfanumericoDirective
              formControlName="puestoTrabajador" id="puesto" name="puesto" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
            <span class=" readOnly p-field-word-break print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.puestoTrabajador.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.puestoTrabajador.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Fecha de ingreso a la empresa" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.fechaIngresoEmpresa.value | date: "dd/MM/yyyy"}}
            </span>
            <p-calendar formControlName="fechaIngresoEmpresa" [showIcon]="true" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" name="ingresoEmpresaDate" [maxDate]="maxDateIngreso" class="print_hide-on-print"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaIngresoEmpresa.invalid}"
              [disabled]="examen?.modoVista === 'ver'">
            </p-calendar>
            <app-invalid-from-message *ngIf="submitted && f.fechaIngresoEmpresa.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Fecha de ingreso al puesto" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.antiguedadPuestoTrabajador.value | date: "dd/MM/yyyy"}}
            </span>
            <p-calendar formControlName="antiguedadPuestoTrabajador" [showIcon]="true" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" name="antiguedadDate" class="print_hide-on-print"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.antiguedadPuestoTrabajador.invalid}"
              [disabled]="examen?.modoVista === 'ver'" [maxDate]="maxDate"
              [minDate]="this.examForm.controls.fechaIngresoEmpresa.value"
              (onSelect)="restrictDateIngresoEmpresa()" (onBlur)="restrictDateIngresoEmpresa()">
            </p-calendar>
            <app-invalid-from-message *ngIf="submitted && f.antiguedadPuestoTrabajador.invalid"></app-invalid-from-message>
          </div>
        </div>
      </div>

      <!-- Seccion Cuadros de Audimetría -->
      <div *ngIf="configForm.findSection('Cuadro de Audiometría')">
        <div class="p-grid">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Cuadro de Audiometría") }}.Cuadro de Audiometría
          </span>
        </div>
        <p-divider></p-divider>
          <section id="audioemtry-table" [ngClass]="{'disabled-table': examen?.modoVista === 'ver'}">
            <div class="p-grid print_show-on-print">
              <div class="p-col-12 p-md-12">
                <app-audiometry-table [airWay]="airWay" [airWayOi]="airWayOi" [viaBone]="viaBone" [viaBoneOi]="viaBoneOi"
                                    (newTableItem)="addTableItems($event)" [submitted]="submitted" (isValid)="isValid($event)">
                </app-audiometry-table>
              </div>
            </div>
          </section>
      </div>
      <!-- Seccion Cuadros de Audimetría -->

      <!-- Seccion Datos del Audiómetro -->
      <div *ngIf="configForm.findSection('Datos del Audiómetro')" class="p-mt-5">
        <div class="p-grid p-mt-5">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Datos del Audiómetro") }}.Datos del Audiómetro
          </span>
        </div>
        <p-divider></p-divider>
        <div class="p-grid p-mt-3">
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Marca" required="true"></app-fiel-title>
            <input formControlName="marca" id="marca" name="marca" maxlength="100" pInputText type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.marca.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.marca.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Fecha de última calibración" required="true"></app-fiel-title>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.fechaUltimaCalibracion.value | date: 'dd/MM/yyyy' }}
            </span>
            <p-calendar formControlName="fechaUltimaCalibracion" [showIcon]="true" dataType="date" dateFormat="dd/mm/yy"
              placeholder="dd/mm/yyyy" id="fechaUltimaCalibracion" inputId="fechaUltimaCalibracion" name="fechaUltimaCalibracion" class="print_hide-on-print"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.fechaUltimaCalibracion.invalid}"
              [disabled]="examen?.modoVista === 'ver'" [maxDate]="maxDate">
            </p-calendar>
            <app-invalid-from-message
              *ngIf="submitted && f.fechaUltimaCalibracion.invalid"></app-invalid-from-message>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Modelo" required="true"></app-fiel-title>
            <input formControlName="modelo" id="modelo" name="modelo" maxlength="100" pInputText type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.modelo.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.modelo.invalid"></app-invalid-from-message>
          </div>

          <div class="p-field p-col-12 p-md-4">
            <app-fiel-title label="Número de serie" required="true"></app-fiel-title>
            <p-inputNumber formControlName="numeroSerie" id="numeroSerie" name="numeroSerie" required
                          [min]="0" [maxFractionDigits]="0" [minFractionDigits]="0"
                          [disabled]="examen?.modoVista === 'ver'" class="print_hide-on-print"
                          [ngClass]="{'ng-invalid ng-dirty': submitted && f.numeroSerie.invalid}">
            </p-inputNumber>
            <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{examForm.controls.numeroSerie.value}}
            </span>
            <app-invalid-from-message *ngIf="submitted && f.numeroSerie.invalid"></app-invalid-from-message>
            <app-invalid-from-message message="Ingrese un número entero menor a 2147483647" *ngIf="f.numeroSerie.hasError('max')"></app-invalid-from-message>
          </div>
          <div class="p-col-12 p-md-6">
            <div class="card flex p-mt-3">
              <app-fiel-title label="Estudio realizado en:" required="true"></app-fiel-title>
              <div class="p-field-checkbox-inline">
                  <div *ngFor="let study of studies " class="p-md-3">
                    <p-checkbox name="group" [value]="study.value" [binary]="true"
                    formControlName="{{study.controlName}}" [inputId]="value"
                    (onChange)="onChangeValueStudy(study.controlName,$event)" [disabled]="examen?.modoVista === 'ver'"></p-checkbox>
                    <label class="p-ml-2" [for]="study.value">{{ study.name }}</label>
                  </div>
              </div>
              <app-invalid-from-message *ngIf="submitted && !f.estudioRealizadoEmpresa.value && !f.estudioRealizadoCabina.value"></app-invalid-from-message>
            </div>
          </div>
        </div>
      </div>
      <!--End Seccion Datos del Audiómetro -->


      <!-- Seccion Otoscopía -->
      <div *ngIf="configForm.findSection('Datos del Audiómetro')">
        <div class="p-grid p-mt-2">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Otoscopía") }}.Otoscopía
          </span>
        </div>
        <p-divider></p-divider>
        <div class="p-grid p-mt-3">
          <div class="p-col-12 p-md-4">
            <div class="card flex">
              <app-fiel-title label="Pabellón Auricular:" required="false"></app-fiel-title>
              <div class="p-field-checkbox-inline p-mt-3">
                  <div *ngFor="let oto of otoscopiaEstudio" class="p-ml-3">
                    <p-checkbox name="group" [value]="oto.value" [binary]="true"
                    formControlName="{{oto.controlName}}" [inputId]="value"
                    (onChange)="onChangeValuePabellon(oto.name, $event)" [disabled]="examen?.modoVista === 'ver'"></p-checkbox>
                    <label class="p-ml-2" [for]="oto.value">{{ oto.name }}</label>
                  </div>
              </div>
            </div>
          </div>
          <div class="p-flied p-col-12 p-md-8">
            <app-fiel-title label="Describir anormalidad:" required="false"></app-fiel-title>
            <span [ngClass]="{'print_show-on-print': f.pabellonAuricularDescripcionAnormal.value.length > 0,
              'print_hide-on-print': f.pabellonAuricularDescripcionAnormal.value.length < 1}"
              class="print-only">
              {{f.pabellonAuricularDescripcionAnormal.value}}
            </span>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.pabellonAuricular.value=='A' && f.pabellonAuricularDescripcionAnormal.invalid}"
            formControlName="pabellonAuricularDescripcionAnormal" id="pabellonAuricularDescripcionAnormal" name="pabellonAuricularDescripcionAnormal" maxlength="250" pInputText type="text"
            [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
            <app-invalid-from-message *ngIf="(submitted && f.pabellonAuricular.value=='A' && f.pabellonAuricularDescripcionAnormal.invalid)"></app-invalid-from-message>
          </div>
        </div>
        <div class="p-grid p-mt-3">
          <div class="p-col-12 p-md-4">
            <div class="card flex">
              <app-fiel-title label="Conducto auditivo externo" required="false"></app-fiel-title>
              <div class="p-field-checkbox-inline p-mt-3">
                  <div *ngFor="let oto of otoscopiaConducto" class="p-ml-3">
                    <p-checkbox name="group" [value]="oto.value" [binary]="true"
                    formControlName="{{oto.controlName}}" [inputId]="value"
                    (onChange)="onChangeValueConducto(oto.name, $event)"
                    [disabled]="examen?.modoVista === 'ver'"></p-checkbox>
                    <label class="p-ml-2" [for]="oto.value">{{ oto.name }}</label>
                  </div>
              </div>
            </div>
          </div>
          <div class="p-flied p-col-12 p-md-8">
            <app-fiel-title label="Describir anormalidad:" required="false"></app-fiel-title>
            <span [ngClass]="{'print_show-on-print': f.conductoAuditivoExternoDescripcionAnormal.value.length > 0,
              'print_hide-on-print': f.conductoAuditivoExternoDescripcionAnormal.value.length < 1}"
              class="print-only">
              {{f.conductoAuditivoExternoDescripcionAnormal.value}}
            </span>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.conductoAuditivoExterno.value=='A' && f.conductoAuditivoExternoDescripcionAnormal.invalid}"
            formControlName="conductoAuditivoExternoDescripcionAnormal" id="conductoAuditivoExternoDescripcionAnormal" name="conductoAuditivoExternoDescripcionAnormal" maxlength="250"
            pInputText type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
            <app-invalid-from-message *ngIf="(submitted && f.conductoAuditivoExterno.value=='A' && f.conductoAuditivoExternoDescripcionAnormal.invalid)"></app-invalid-from-message>
          </div>
        </div>
        <div class="p-grid p-mt-3">
          <div class="p-col-12 p-md-4">
            <div class="card flex">
              <app-fiel-title label="Membrana Timpánica" required="false"></app-fiel-title>
              <div class="p-field-checkbox-inline p-mt-3">
                  <div *ngFor="let oto of otoscopiaMembrana" class="p-ml-3">
                    <p-checkbox name="group" [value]="oto.value" [binary]="true"
                    formControlName="{{oto.controlName}}" [inputId]="value"
                    (onChange)="onChangeValueMembrana(oto.name, $event)"
                    [disabled]="examen?.modoVista === 'ver'"></p-checkbox>
                    <label class="p-ml-2" [for]="oto.value">{{ oto.name }}</label>
                  </div>
              </div>
            </div>
          </div>
          <div class="p-flied p-col-12 p-md-8">
            <app-fiel-title label="Describir anormalidad:" required="false"></app-fiel-title>
            <span [ngClass]="{'print_show-on-print': f.membranaTimpanicaDescripcionAnormal.value.length > 0,
              'print_hide-on-print': f.membranaTimpanicaDescripcionAnormal.value.length < 1}"
              class="print-only">
              {{f.membranaTimpanicaDescripcionAnormal.value}}
            </span>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.membranaTimpanica.value=='A' && f.membranaTimpanicaDescripcionAnormal.invalid}"
            formControlName="membranaTimpanicaDescripcionAnormal" id="membranaTimpanicaDescripcionAnormal" name="membranaTimpanicaDescripcionAnormal"
            maxlength="250" pInputText type="text" [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
            <app-invalid-from-message *ngIf="(submitted && f.membranaTimpanica.value=='A' && f.membranaTimpanicaDescripcionAnormal.invalid)"></app-invalid-from-message>
          </div>
        </div>
      </div>
      <!-- Seccion Otoscopía -->

      <!-- Seccion Cuestionario Técnico -->
      <div *ngIf="configForm.findSection('Cuestionario Técnico')">
        <div class="p-grid p-mt-5">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Cuestionario Técnico") }}.Cuestionario Técnico
          </span>
        </div>
        <p-divider></p-divider>
        <div class="p-grid p-mt-3">
          <div class="p-col-12 p-md-12">
            <p-checkbox-question label="¿Trabaja en ambiente ruidoso?" [checkBoxes]="tecnico" [checked]="ambienteRuidoso"
            (onChangeValue)="onChangeValueTecnic('ambienteRuidoso',$event)" [disabled]="examen?.modoVista === 'ver'"></p-checkbox-question>
          </div>
          <div class="p-col-12 p-md-12">
            <p-checkbox-question label="¿Siente acúfenos?" [checkBoxes]="tecnico" [checked]="acufenos"
            (onChangeValue)="onChangeValueTecnic('acufenos',$event)" [disabled]="examen?.modoVista === 'ver'"></p-checkbox-question>
          </div>
          <div class="p-col-12 p-md-12">
            <p-checkbox-question label="¿Exposición ruído extra laboral?" [checkBoxes]="tecnico" [checked]="ruidoExtralaboral"
            (onChangeValue)="onChangeValueTecnic('ruidoExtralaboral',$event)" [disabled]="examen?.modoVista === 'ver'"></p-checkbox-question>
        </div>
          <div class="p-col-12 p-md-12">
            <p-checkbox-question label="¿Se dificulta entender una conversación en su ambiente de trabajo?" [checkBoxes]="tecnico" [checked]="entenderConversacion"
            (onChangeValue)="onChangeValueTecnic('entenderConversacion',$event)" [disabled]="examen?.modoVista === 'ver'"></p-checkbox-question>
          </div>
          <div class="p-col-12 p-md-6">
            <p-checkbox-question label="¿Usa protección auditiva?" [checkBoxes]="tecnico" [checked]="proteccionAuditiva"
            (onChangeValue)="onChangeValueTecnic('proteccionAuditiva',$event)" [disabled]="examen?.modoVista === 'ver'"></p-checkbox-question>
          </div>
          <div class="p-col-12 p-md-6 p-mt-2">
              <div [ngClass]="{'print_show-on-print': f.proteccionAuditiva.value,
                'print_hide-on-print': !f.proteccionAuditiva.value}">
                <app-fiel-title label="¿Qué tipo de protectores usa como EPP?" required="f.proteccionAuditiva.value ? true : false"></app-fiel-title>
              </div>
              <span class="print_edadInputNumber_hide print_show-on-print print_filled_input">
              {{ f.listaProtectores.value?.name }}
            </span>
            <p-dropdown id="name" [options]="hearingProtection" placeholder="Seleccione" [disabled]="examen?.modoVista === 'ver'"
                      optionLabel="name" [showClear]="true" formControlName="listaProtectores" class="print_hide-on-print"
                      [ngClass]="{'ng-invalid ng-dirty': submitted && f.proteccionAuditiva.value && f.listaProtectores.invalid}">
            </p-dropdown>
            <app-invalid-from-message *ngIf="submitted && f.listaProtectores.invalid"></app-invalid-from-message>
          </div>
          <div class="p-col-12 p-md-12">
            <p-checkbox-question label="¿Cumple reposo auditivo?" [checkBoxes]="tecnico" [checked]="reposoAuditivo"
            (onChangeValue)="onChangeValueTecnic('reposoAuditivo',$event)" [disabled]="examen?.modoVista === 'ver'"></p-checkbox-question>
          </div>
          <div class="p-col-12 p-md-12">
            <p-checkbox-question label="¿Fue indemnizado anteriormente por hipoacusia?" [checkBoxes]="tecnico" [checked]="indemnizadoHipoacusia"
            (onChangeValue)="onChangeValueTecnic('indemnizadoHipoacusia',$event)" [disabled]="examen?.modoVista === 'ver'"></p-checkbox-question>
          </div>

          <div class="p-col-12 p-md-12">
            <p-checkbox-question label="¿Grita en el trabajo para comunicarse?" [checkBoxes]="tecnico" [checked]="grita"
            (onChangeValue)="onChangeValueTecnic('grita',$event)" [disabled]="examen?.modoVista === 'ver'"></p-checkbox-question>
          </div>

          <div class="p-col-12 p-md-12">
            <p-checkbox-question label="¿Tiene capacitación sobre el uso de EPP?" [checkBoxes]="tecnico" [checked]="capacitacionEpp"
            (onChangeValue)="onChangeValueTecnic('capacitacionEpp',$event)" [disabled]="examen?.modoVista === 'ver'"></p-checkbox-question>
          </div>

          <div class="p-col-12 p-md-12">
            <p-checkbox-question label="¿Es obligatoria la protección auditiva en su área?"  [checkBoxes]="tecnico" [checked]="proteccionAuditivaObligatoria"
            (onChangeValue)="onChangeValueTecnic('proteccionAuditivaObligatoria',$event)" [disabled]="examen?.modoVista === 'ver'"></p-checkbox-question>
          </div>

          <div class="p-col-12 p-md-12">
            <p-checkbox-question label="¿Protección auditiva no provista en su área?" [checkBoxes]="tecnico" [checked]="proteccionAuditivaNoProvista"
            (onChangeValue)="onChangeValueTecnic('proteccionAuditivaNoProvista',$event)" [disabled]="examen?.modoVista === 'ver'"></p-checkbox-question>
          </div>

          <div class="p-col-12 p-md-12">
            <p-checkbox-question label="¿Le trae inconvenientes?" [checkBoxes]="tecnico" [checked]="inconvenientes"
            (onChangeValue)="onChangeValueTecnic('inconvenientes',$event)" [disabled]="examen?.modoVista === 'ver'"></p-checkbox-question>
          </div>
          <div class="p-col-6 p-md-6 print_row-full">
            <div [ngClass]="{'print_show-on-print': f.inconvenientesDescipcion.value.length > 0,
              'print_hide-on-print': f.inconvenientesDescipcion.value.length < 1}">
              <app-fiel-title label="Descripción"></app-fiel-title>
            </div>
            <span [ngClass]="{'print_show-on-print': f.inconvenientesDescipcion.value.length > 0,
                  'print_hide-on-print': f.inconvenientesDescipcion.value.length < 1}"
                  class="print-only p-field-word-break">
                  {{f.inconvenientesDescipcion?.value}}
            </span>
            <input [ngClass]="{'ng-invalid ng-dirty': (submitted && f.inconvenientes.value && f.inconvenientesDescipcion.invalid) || (f.inconvenientes.value && f.inconvenientesDescipcion.invalid)}"
            formControlName="inconvenientesDescipcion" id="inconvenientesDescipcion" name="inconvenientesDescipcion" maxlength="250" pInputText type="text"
            [attr.disabled]="examen?.modoVista === 'ver' ? true : null">
            <app-invalid-from-message *ngIf="(submitted && f.inconvenientes.value && f.inconvenientesDescipcion.invalid) || (f.inconvenientes.value && f.inconvenientesDescipcion.invalid)"></app-invalid-from-message>
          </div>
        </div>
      </div>
      <!-- Seccion Cuestionario Técnico -->

      <!-- Seccion Cuestionario Clínico -->
      <div *ngIf="configForm.findSection('Cuestionario Clínico')">
        <div class="p-grid p-mt-5">
          <span class="p-title-seccion">
            {{ configForm.findNumberSection("Cuestionario Clínico") }}.Cuestionario Clínico
          </span>
        </div>
        <p-divider></p-divider>
        <span class="p-mt-5"></span>
        <app-fiel-title label="¿Ha padecido en el último año?" required="true"></app-fiel-title>
        <div class="p-grid p-mt-3">
          <div *ngFor="let suffer of suffered " class="field-checkbox p-col-12 p-md-4">
            <p-checkbox name="group" [value]="suffer.checked" [binary]="true" [(ngModel)]="suffer.checked"
            formControlName="{{suffer.controlName}}" [inputId]="checked"
            (onChange)="onChangeValueNothing(suffer.controlName,$event)"
            [disabled]="examen?.modoVista === 'ver'"></p-checkbox>
            <label class="p-ml-2" [for]="suffer.value">{{ suffer.name }}</label>
          </div>
          <div class="p-mt-3">
            <app-invalid-from-message *ngIf="(submitted && !f.padecidoNada.value &&
            !f.infeccionOido.value && !f.dolorOido.value && !f.supuracion.value && !f.taponCera.value && !f.padecidoOtro.value)"></app-invalid-from-message>
          </div>
        </div>
        <div class="p-grid p-mt-3">
            <div class="p-flied p-col-12 p-md-6">
              <div [ngClass]="{'print_show-on-print': f.padecidoOtroDescripcion.value.length > 0,
                'print_hide-on-print': f.padecidoOtroDescripcion.value.length < 1}">
                <app-fiel-title label="Descripción"></app-fiel-title>
              </div>
              <span [ngClass]="{'print_show-on-print': f.padecidoOtroDescripcion.value.length > 0,
                'print_hide-on-print': f.padecidoOtroDescripcion.value.length < 1}"
                class="print-only p-field-word-break">
                {{f.padecidoOtroDescripcion?.value}}
              </span>
              <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.padecidoOtro.value && f.padecidoOtroDescripcion.invalid}"
              formControlName="padecidoOtroDescripcion" id="padecidoOtroDescripcion" name="padecidoOtroDescripcion"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null"
              maxlength="200" pInputText type="text"/>
              <app-invalid-from-message *ngIf="(submitted && f.padecidoOtro.value && f.padecidoOtroDescripcion.invalid)"></app-invalid-from-message>
            </div>
        </div>
        <div class="p-grid p-mt-3">
          <div class="p-flied p-col-12 p-md-6">
            <p-checkbox-question label="¿Enfermedades de la infancia, congénitas o adquiridas?" [checkBoxes]="tecnico" [checked]="enfermedades"
            [disabled]="examen?.modoVista === 'ver'" (onChangeValue)="onChangeValueClinic('enfermedades',$event)"></p-checkbox-question>
            <app-invalid-from-message *ngIf="submitted && f.enfermedades.value==null"></app-invalid-from-message>
          </div>
        </div>
        <div class="p-grid p-mt-2">
          <div class="p-flied p-col-12 p-md-6">
            <div [ngClass]="{'print_show-on-print': f.enfermedadesDescripcion.value.length > 0,
              'print_hide-on-print': f.enfermedadesDescripcion.value.length < 1}">
              <app-fiel-title label="Descripción"></app-fiel-title>
            </div>
            <span [ngClass]="{'print_show-on-print': f.enfermedadesDescripcion.value.length > 0,
              'print_hide-on-print': f.enfermedadesDescripcion.value.length < 1}"
              class="print-only p-field-word-break">
              {{f.enfermedadesDescripcion?.value}}
            </span>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.enfermedades.value && f.enfermedadesDescripcion.invalid}"
            formControlName="enfermedadesDescripcion" id="enfermedadesDescripcion" name="enfermedadesDescripcion"
            [attr.disabled]="examen?.modoVista === 'ver' ? true : null" maxlength="250" pInputText type="text">
            <app-invalid-from-message *ngIf="(submitted && f.enfermedades.value && f.enfermedadesDescripcion.invalid)"></app-invalid-from-message>
          </div>
        </div>
        <div class="p-grid p-mt-3">
          <div class="p-flied p-col-12 p-md-6">
            <p-checkbox-question label="¿Exposiciones ototóxicas?" [checkBoxes]="tecnico" [checked]="exposicionesOtotoxicas"
            [disabled]="examen?.modoVista === 'ver'" (onChangeValue)="onChangeValueClinic('exposicionesOtotoxicas',$event)"></p-checkbox-question>
            <app-invalid-from-message *ngIf="submitted && f.exposicionesOtotoxicas.value==null"></app-invalid-from-message>
          </div>
        </div>
        <div class="p-grid p-mt-2">
          <div class="p-flied p-col-12 p-md-6">
            <div [ngClass]="{'print_show-on-print': f.exposicionesOtotoxicasDescripcion.value.length > 0,
              'print_hide-on-print': f.exposicionesOtotoxicasDescripcion.value.length < 1}">
              <app-fiel-title label="Descripción"></app-fiel-title>
            </div>
            <span [ngClass]="{'print_show-on-print': f.exposicionesOtotoxicasDescripcion.value.length > 0,
              'print_hide-on-print': f.exposicionesOtotoxicasDescripcion.value.length < 1}"
              class="print-only p-field-word-break">
              {{f.exposicionesOtotoxicasDescripcion?.value}}
            </span>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.exposicionesOtotoxicas.value && f.exposicionesOtotoxicasDescripcion.invalid}"
            formControlName="exposicionesOtotoxicasDescripcion" id="exposicionesOtotoxicasDescripcion" name="exposicionesOtotoxicasDescripcion"
            [attr.disabled]="examen?.modoVista === 'ver' ? true : null" maxlength="250" pInputText type="text" [disabled]="examen?.modoVista === 'ver'">
            <app-invalid-from-message *ngIf="(submitted && f.exposicionesOtotoxicas.value && f.exposicionesOtotoxicasDescripcion.invalid)"></app-invalid-from-message>
          </div>
        </div>
      </div>
      <!-- Seccion Cuestionario Clínico -->

      <!--Seccion Dictamen medico-->
      <div class="print_hide-on-print p-mt-5" *ngIf="configForm.findSection('Dictamen medico')">
        <label class="p-title-seccion">
          {{ configForm.findNumberSection("Dictamen medico") }}.Dictamen médico
        </label>
        <p-divider></p-divider>

        <div class="p-grid">
          <!--Campo Tipo Dictamen-->
          <div *ngIf="configForm.findField('codigoDictamen')" class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Tipo de dictamen" required="true"></app-fiel-title>
            <div style="display: flex; flex-direction: row;"
              [ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid }">

              <div *ngFor="let item of tiposDictamen" class="p-field-checkbox">

                <p-radioButton name="codigoDictamen" [value]="item.codigo" formControlName="codigoDictamen"
                  label="{{ item.descripcion }}"
                  [ngClass]="{'ng-invalid ng-dirty': submitted && f.codigoDictamen.invalid}"
                  [disabled]="examen?.modoVista === 'ver'" [(ngModel)]="examen.codigoDictamen">
                </p-radioButton>

              </div>
            </div>
            <app-invalid-from-message *ngIf="submitted && f.codigoDictamen.invalid"></app-invalid-from-message>
          </div>

          <!--Campo Especialidades-->
          <div class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Especialidad" required="true"></app-fiel-title>
            <p-dropdown [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoEspecialidad.invalid}"
              [options]="especialidades" formControlName="medicoEspecialidad" placeholder="Seleccione"
              optionLabel="descripcion" optionValue="codigo" [showClear]="true"
              [disabled]="examen?.modoVista === 'ver'">
            </p-dropdown>
            <app-invalid-from-message *ngIf="submitted && f.medicoEspecialidad.invalid"></app-invalid-from-message>
          </div>

          <!--Campo Médico-->
          <div *ngIf="configForm.findField('medicoNombre')" class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Médico" required="true"></app-fiel-title>
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoNombre.invalid}" alfanumericoDirective
              formControlName="medicoNombre" id="medico" name="medico" maxlength="100" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
            <app-invalid-from-message *ngIf="submitted && f.medicoNombre.invalid"></app-invalid-from-message>
          </div>

          <!--Campo Matricula-->
          <div class="p-field p-col-12 p-md-6">
            <app-fiel-title label="Matrícula" required="true"></app-fiel-title>
            <!-- Modificar para validar el formato de la matricula -->
            <input [ngClass]="{'ng-invalid ng-dirty': submitted && f.medicoMatricula.invalid}" numberDirective
              formControlName="medicoMatricula" id="medicoMatricula" name="medicoMatricula" maxlength="18" pInputText type="text"
              [attr.disabled]="examen?.modoVista === 'ver' ? true : null" />
            <app-invalid-from-message *ngIf="submitted && f.medicoMatricula.invalid"></app-invalid-from-message>
          </div>
        </div>
        <div class="p-grid p-form-footer">
          <div class="p-field p-col-12 p-md-12" style="justify-content: flex-start; display: flex;">
            <button [disabled]="examen?.modoVista === 'ver' ? true : null" pButton pRipple type="button" label="Firmar" (click)="showModalFirma()"></button>
          </div>
          <div class="p-field p-col-12 p-md-12">
            <app-invalid-from-message *ngIf="submitted && medicoFirmaB64 == null" message="Por favor firmar el estudio"></app-invalid-from-message>
          </div>
        </div>
      </div>

      <!-- ------------ ADJUNTAR ARCHIVO ------------ -->
      <div *ngIf="configForm.findSection('Adjuntos')" class="p-grid-space print_hide-on-print">
        <label class="p-title-seccion">
          {{ configForm.findNumberSection("Adjuntos") }}.Archivos adjuntos
          <strong *ngIf="attachedFiles.attachedFilesValidQuantity >= 1">:</strong>
          <span style="font-weight: normal;" *ngIf="attachedFiles.data.length >= 1">
            {{ attachedFiles.attachedFilesValidQuantity }}
          </span>
        </label>
        <p-divider></p-divider>

        <app-attach-upload-file [examenNumero]="this.examen?.id"
          [isRequire]="configForm.isAttachedFileRequire" (filesAttachedData)="getAttachedFiles($event)"
          [attachedFilesFromBackend]="this.examen?.attachments" [viewMode]="this.examen?.modoVista"
          [esAunPorEnviar]="this.examen?.aunPorEnviar || false">
        </app-attach-upload-file>

        <app-attached-file-mandatory-message
          *ngIf=" submitted &&  configForm.isAttachedFileRequire && attachedFiles.isEmpty  ">
        </app-attached-file-mandatory-message>
      </div>

      <app-print-footer [firmaB64]="examen?.firmaB64"
                        [medicoFirmaB64]="medicoFirmaB64"
                        [trabajadorApellidoNombre]="f.apellidoNombre.value"
                        [medicoNombre]="f.medicoNombre?.value"
                        [medicoEspecialidad]="f.medicoEspecialidad.value"
                        [medicoMatricula]="f.medicoMatricula?.value">
      </app-print-footer>

      <div class="p-grid p-form-footer">
        <div class="p-col-12 p-md-12" style="justify-content: flex-end; display: flex;">
          <ng-container *ngIf="examen?.modoVista === 'ver'">
            <button pButton pRipple type="button" label="Volver" class="p-button-text" (click)="goBack()"></button>
          </ng-container>
          <ng-container *ngIf="examen?.modoVista !== 'ver'">
            <button pButton pRipple type="button" label="Cancelar" class="p-button-text" (click)="goBack()"></button>
            <p-button type="submit" label="Guardar" *ngIf="!enviandose"
              [disabled]="examen?.modoVista === 'edit' && !isOnline && !examen?.aunPorEnviar">
            </p-button>
            <p-button type="submit" label="Enviando..." *ngIf="enviandose" disabled="true"></p-button>
          </ng-container>
        </div>
      </div>
    </div>
  </form>
  <p-confirmDialog key="goBackForm" [closable]="false" #cd [style]="{ width: '500px' }" styleClass="p-dialog-custom">
    <p-footer>
      <button type="button" class="p-button-text" pButton label="No, volver al examen" (click)="cd.reject()"></button>
      <button type="button" pButton label="Si, cancelar carga" (click)="cd.accept()"></button>
    </p-footer>
  </p-confirmDialog>
</main>

<section id="modal-firma">
	<app-topaz (datosFirma)="recibirDatosFirma($event)" [displayModalFirma]="displayModalFirma" (closeModal)="closeModalFirma()"></app-topaz>
</section>
